import { render, staticRenderFns } from "./GoVolume.vue?vue&type=template&id=54531758&scoped=true&"
import script from "./GoVolume.vue?vue&type=script&lang=js&"
export * from "./GoVolume.vue?vue&type=script&lang=js&"
import style0 from "./GoVolume.vue?vue&type=style&index=0&id=54531758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54531758",
  null
  
)

export default component.exports